<div>
	<div class="modal-header">
		<h4 class="modal-title">Ajouter une nouvelle société</h4>
		<button type="button" class="close" aria-label="Close" (click)="cancelDialog()"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body">
		<form [formGroup]="companyAddForm">
			<div class="form-group">
				<label for="name">Nom</label>
				<input required #nameControl id="name" type="text" class="form-control" formControlName="nameControl" placeholder="Nom" ngbAutofocus (input)="nameControl.value = nameControl.value.toUpperCase()">
			</div>
		</form>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-light" (click)="cancelDialog()">Annuler</button>
		<button type="submit" class="btn btn-primary" [disabled]="!enableAction || !companyAddForm.valid" (click)="save()">{{buttonText}}</button>
	</div>
</div>
